var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceDiagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 139,
    viewBox: "0 0 105 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26576_3806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7115 117.07H52.2891V126.943H52.7115V117.07Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7115 0.972656H52.2891V99.2358H52.7115V0.972656Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7832 136.76H52.5V136.337H60.7283L81.654 124.266L90.6933 109.011L101.726 50.9524L96.2225 21.0984L84.3067 8.96828L71.2419 1.18452H52.5042V0.761719H71.301C71.339 0.761719 71.377 0.770175 71.4108 0.791315L84.5517 8.61736C84.5517 8.61736 84.5812 8.6385 84.5939 8.65118L96.5731 20.849C96.6027 20.8786 96.6238 20.9166 96.6323 20.9589L102.153 50.9186C102.157 50.944 102.157 50.9693 102.153 50.9947L91.1073 109.13C91.1031 109.155 91.0946 109.176 91.082 109.197L81.9961 124.532C81.9792 124.562 81.9497 124.592 81.9201 124.609L60.8973 136.734C60.8635 136.751 60.8297 136.764 60.7917 136.764L60.7832 136.76Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.424 72.2948H78.4156L69.4185 71.8508C69.3889 71.8508 69.3636 71.8424 69.3382 71.8297L63.4584 69.0646C63.3866 69.0308 63.3402 68.9589 63.3359 68.8785C63.3359 68.7982 63.3782 68.7221 63.45 68.6883L69.5959 65.568C69.6255 65.5511 69.6593 65.5469 69.693 65.5469H78.9563C79.0069 65.5469 79.0534 65.5638 79.0914 65.5976L83.3661 69.166C83.421 69.2083 83.4464 69.276 83.4421 69.3479C83.4379 69.4155 83.3957 69.4789 83.3365 69.5127L78.5254 72.2779C78.4916 72.2948 78.4578 72.3075 78.4198 72.3075L78.424 72.2948ZM69.4776 71.428L78.3691 71.8677L82.8635 69.2844L78.8802 65.9612H69.7437L64.0287 68.8616L69.4776 71.4238V71.428Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7651 90.9317C61.7229 90.9317 61.6806 90.919 61.6468 90.8979L56.747 87.6C56.6921 87.562 56.6541 87.4986 56.6541 87.4309L56.2106 67.9948C56.2106 67.944 56.2275 67.8975 56.257 67.8552L64.4516 57.7799C64.4811 57.7419 64.5234 57.7165 64.5699 57.708L82.205 53.6956C82.2642 53.683 82.3275 53.6956 82.3782 53.7337L91.7006 60.8156L93.8844 39.5572L90.8853 25.6893L73.8457 16.8528L66.3313 18.2227C66.3313 18.2227 66.2932 18.2269 66.2721 18.2227L52.4766 16.8401L52.5188 16.4173L66.2848 17.7956L73.8373 16.4173C73.8838 16.4088 73.9302 16.4173 73.9725 16.4384L91.1641 25.3553C91.219 25.3849 91.2613 25.4356 91.2739 25.4991L94.3025 39.498C94.3068 39.5191 94.3068 39.5403 94.3025 39.5656L92.0765 61.23C92.068 61.3061 92.0216 61.3737 91.9498 61.4033C91.878 61.4329 91.7977 61.4244 91.7386 61.3779L82.1966 54.1269L64.7261 58.1012L56.6245 68.0582L57.0638 87.3083L61.6046 90.3652L63.3238 80.5646L60.574 68.9714C60.5528 68.8869 60.5909 68.7939 60.6627 68.7474L69.3007 63.0861C69.3641 63.0438 69.4401 63.0395 69.5077 63.0734C69.5753 63.103 69.6175 63.1706 69.626 63.2425L69.8921 65.737L69.4739 65.7835L69.2416 63.6315L61.0133 69.0222L63.7419 80.5139C63.7504 80.5435 63.7504 80.5689 63.7419 80.5985L61.9594 90.7626C61.9467 90.8345 61.9003 90.8937 61.8327 90.919C61.8074 90.9317 61.7778 90.9359 61.7482 90.9359L61.7651 90.9317Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0008 16.7992L73.7473 16.461L83.9652 8.88439L63.5084 2.66499H52.4922V2.24219H63.5379C63.5379 2.24219 63.5802 2.24219 63.6013 2.25064L84.4932 8.60111C84.5692 8.62648 84.6283 8.6899 84.641 8.766C84.6537 8.84634 84.6241 8.92667 84.5607 8.97318L74.005 16.7992H74.0008Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8749 16.8363C73.8538 16.8363 73.8327 16.8363 73.8116 16.8278L52.434 9.87275C52.3579 9.84739 52.2988 9.77974 52.2903 9.69941C52.2819 9.61907 52.3157 9.53874 52.3833 9.49646L63.429 2.27502C63.4501 2.25811 63.4797 2.24966 63.505 2.24543L71.2561 0.765625L71.3363 1.17997L63.9148 2.59635L74.0523 16.5023C74.1073 16.5784 74.1073 16.6756 74.0523 16.7517C74.0101 16.8067 73.9467 16.8405 73.8792 16.8405L73.8749 16.8363ZM52.9831 9.60639L73.3216 16.2232L63.4924 2.73588L52.9831 9.60639Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.164 65.7918L78.75 65.7157L79.1977 63.217C79.202 63.1916 79.2146 63.162 79.2273 63.1409L82.9993 57.2978L82.0447 53.9576C82.0363 53.9323 82.0363 53.9069 82.0363 53.8815L83.2317 39.1046L81.8082 27.6171L82.2264 27.5664L83.6541 39.075C83.6541 39.075 83.6541 39.1046 83.6541 39.1173L82.4587 53.8773L83.426 57.2724C83.4429 57.3316 83.4344 57.395 83.4006 57.4457L79.599 63.3354L79.1597 65.7918H79.164Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2264 69.5335C83.1546 69.5335 83.087 69.4997 83.049 69.4363L79.2812 63.4705H69.5069L63.6904 69.0304C63.6524 69.0684 63.6017 69.0896 63.5468 69.0896L60.7843 69.1361C60.721 69.1361 60.6323 69.0938 60.5943 69.0219C60.5562 68.95 60.5647 68.8655 60.6111 68.8021L66.8922 60.1516C66.926 60.1093 66.9725 60.0797 67.0232 60.067L83.1926 57.1243C83.2686 57.1116 83.3404 57.137 83.3911 57.192L91.5434 66.5105C91.5899 66.5654 91.6068 66.6373 91.5899 66.705C91.573 66.7726 91.5181 66.8276 91.4505 66.8487L83.2982 69.5251C83.2771 69.5335 83.256 69.5335 83.2306 69.5335H83.2264ZM69.4182 63.0477H79.3952C79.4671 63.0477 79.5346 63.0858 79.5726 63.145L83.3151 69.0684L91.007 66.5443L83.1461 57.5598L67.1795 60.4644L61.1983 68.7006L63.4539 68.6625L69.2746 63.1027C69.3126 63.0647 69.3675 63.0435 69.4224 63.0435L69.4182 63.0477Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7832 69.1338C60.7832 69.1338 60.7537 69.1338 60.741 69.1296L56.3987 68.1994H52.5V67.7766H56.4199C56.4199 67.7766 56.4494 67.7766 56.4621 67.7808L60.6439 68.6772L64.4117 57.8408C64.437 57.7731 64.4919 57.7224 64.5637 57.7055C64.6313 57.6886 64.7073 57.7055 64.758 57.7605L67.2079 60.1239L66.9165 60.4283L64.7031 58.2932L60.9818 68.9943C60.9522 69.0788 60.8719 69.138 60.7832 69.138V69.1338Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2181 71.6309L69.0391 76.1133L69.4611 76.1302L69.6402 71.6478L69.2181 71.6309Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5492 71.907L78.2969 72.2461L83.7068 76.2794L83.9592 75.9404L78.5492 71.907Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0099 108.8L75.875 119.5L76.295 119.545L77.4299 108.844L77.0099 108.8Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8211 99.4458H52.5V99.023H56.8211C57.045 98.9723 60.5129 97.6658 63.0389 96.7061L58.2911 94.1693L55.2709 95.7252C55.2414 95.7421 55.2076 95.7505 55.1738 95.7505H52.5V95.3277H55.1231L58.1939 93.7465C58.2573 93.7126 58.3291 93.7169 58.3882 93.7465L63.6429 96.5539C63.7147 96.5919 63.7612 96.6722 63.7527 96.7526C63.7485 96.8371 63.6936 96.909 63.6175 96.9386C59.2499 98.6044 56.9605 99.4501 56.8169 99.4501L56.8211 99.4458Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6632 99.3813L55.4171 98.0453C55.3876 98.0157 55.3707 97.9776 55.3622 97.9353L54.9609 95.5719L55.3791 95.5L55.7677 97.8L56.9716 99.0896L56.6632 99.3771V99.3813Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5005 93.9269L58.0781 93.9336L58.1227 96.7406L58.545 96.7339L58.5005 93.9269Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5673 98.1135H52.4922V97.6907H55.5208L58.241 96.5492C58.2664 96.5365 58.296 96.5323 58.3213 96.5323H63.2507L61.5484 90.7864L56.6021 68.12L57.0161 68.0312L61.9582 90.6807L63.7365 96.6845C63.7533 96.7479 63.7449 96.8155 63.7027 96.8705C63.6646 96.9255 63.6013 96.9551 63.5337 96.9551H58.3635L55.6433 98.0966C55.6179 98.1093 55.5884 98.1135 55.563 98.1135H55.5673Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8058 124.636C81.7551 124.636 81.7086 124.619 81.6664 124.585L75.9429 119.681C75.9133 119.655 75.8922 119.626 75.8795 119.592L69.9533 102.79L63.4018 96.8958L63.6849 96.583L70.2785 102.511C70.3038 102.536 70.325 102.566 70.3376 102.595L76.2639 119.393L81.4045 123.799L77.02 108.878C77.0031 108.819 77.0115 108.755 77.0453 108.7L90.3298 88.5117L91.1492 67.2786L84.0022 76.2505C83.9642 76.3012 83.9009 76.3308 83.8375 76.3308H69.2521C69.2014 76.3308 69.1549 76.3139 69.1169 76.2801L60.6562 69.0798L60.9308 68.7584L69.3323 75.908H83.7404L91.2253 66.5134C91.2802 66.4415 91.3773 66.4161 91.4618 66.4457C91.5463 66.4795 91.6012 66.5599 91.6012 66.6529L90.7564 88.5878C90.7564 88.6259 90.7437 88.6639 90.7226 88.6977L77.4593 108.857L82.017 124.365C82.0423 124.454 82.0085 124.551 81.9283 124.602C81.8945 124.623 81.8522 124.636 81.8142 124.636H81.8058Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5237 120.044L52.4772 119.625L60.6929 118.695L66.277 113.685L61.4109 116.188C61.3898 116.201 61.3645 116.209 61.3391 116.209L52.5194 117.279L52.4688 116.86L61.2504 115.795L67.54 112.556C67.6329 112.505 67.7512 112.535 67.8103 112.624C67.8694 112.712 67.8568 112.831 67.7765 112.903L60.9167 119.054C60.8829 119.084 60.8449 119.101 60.7985 119.105L52.5152 120.04L52.5237 120.044Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1131 115.95L60.5781 118.848L60.9935 118.924L61.5285 116.027L61.1131 115.95Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0514 113.645L67.6267 112.956H52.4964V112.533H66.7016L61.4892 110.056L55.1955 109.925L52.5513 110.588C52.4541 110.61 52.357 110.567 52.3105 110.479C52.2683 110.39 52.2894 110.284 52.3654 110.221L54.6379 108.394C54.6759 108.365 54.7224 108.348 54.7689 108.348H60.7796C60.8176 108.348 60.8556 108.36 60.8894 108.377L67.707 112.542L74.0936 113.227L74.0472 113.645H74.0514ZM55.1659 109.502H55.1701L61.5399 109.637C61.5695 109.637 61.5991 109.646 61.6244 109.658L64.0954 110.834L60.7163 108.77H54.8365L53.375 109.95L55.1152 109.515C55.1152 109.515 55.149 109.51 55.1659 109.51V109.502Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6565 99.227L54.2344 99.2422L54.5692 108.559L54.9913 108.544L54.6565 99.227Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8743 108.878L87.7578 109.055L87.7818 109.477L90.8983 109.3L90.8743 108.878Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3983 96.3753L93.2969 95.9652L95.713 95.3521L102.805 82.0043L104.575 67.6586L102.273 62.7076L99.654 63.5237L99.5273 63.122L102.324 62.251C102.425 62.2214 102.535 62.2679 102.577 62.3652L104.98 67.536C104.997 67.5698 105.002 67.6121 104.997 67.6502L103.215 82.0931C103.215 82.1184 103.202 82.1438 103.194 82.1649L96.0382 95.6269C96.0087 95.6776 95.9622 95.7199 95.9031 95.7326L93.3983 96.3668V96.3753Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1982 90.0421C97.1982 90.0421 97.1813 90.0421 97.177 90.0421L94.5877 89.7631C94.4948 89.7546 94.4188 89.6827 94.4019 89.5897C94.385 89.4967 94.4314 89.4037 94.5159 89.3614L97.2193 88.0127L98.3809 83.0152L96.3745 79.4171C96.3407 79.3579 96.3407 79.2861 96.366 79.2269L101.756 67.2743C101.794 67.1855 101.887 67.1348 101.984 67.1517C102.081 67.1686 102.153 67.2489 102.157 67.3462L103.226 82.0596L102.803 82.0892L101.95 70.365L101.084 83.0025C101.084 83.0321 101.072 83.0617 101.059 83.087L97.384 89.9322C97.346 89.9998 97.2742 90.0421 97.1982 90.0421ZM95.3481 89.4206L97.0799 89.6066L100.666 82.9264L101.65 68.5215L96.7884 79.303L98.7822 82.8799C98.8075 82.9264 98.816 82.9813 98.8033 83.0321L97.5994 88.2071C97.5868 88.2706 97.5445 88.3213 97.4896 88.3467L95.3438 89.4206H95.3481Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.769 67.8406L101.918 67.5742C101.804 67.5615 101.715 67.4601 101.728 67.3459L102.171 62.4414L102.594 62.4795L102.167 67.1725L104.807 67.422L104.769 67.8448V67.8406Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9938 136.594L60.5799 136.506L61.8302 130.519L59.0212 127.153H52.5078V126.73H59.1226C59.1859 126.73 59.2451 126.76 59.2831 126.807L62.223 130.329C62.2652 130.379 62.2821 130.443 62.2695 130.506L61.0023 136.59L60.9938 136.594Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0527 130.674C62.002 130.674 61.9514 130.657 61.9133 130.619C61.85 130.564 61.8289 130.475 61.8542 130.399L67.4425 112.68L67.8438 112.807L62.3949 130.082L73.9095 124.979L75.8821 119.449L76.2791 119.592L74.277 125.211C74.2558 125.266 74.2178 125.309 74.1629 125.334L62.1372 130.661C62.1119 130.674 62.0823 130.678 62.0527 130.678V130.674Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7018 121.457L58.9688 126.797L59.2565 127.106L64.9895 121.766L64.7018 121.457Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.852 51.1472L97.9324 49.4517C97.8817 49.4306 97.8394 49.3883 97.8183 49.3376L93.8984 39.6174L94.2913 39.4609L98.1773 49.1008L102.017 50.7624L101.848 51.1514L101.852 51.1472Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7588 79.3334L96.3406 79.2869L98.1105 63.3896L97.8063 49.2638L96.2266 21.4309L91.2042 25.7011L90.9297 25.3798L96.273 20.8347C96.3364 20.784 96.4209 20.7713 96.4927 20.8009C96.5645 20.8305 96.6152 20.9024 96.6194 20.9827L98.2245 49.2469L98.5286 63.4107L96.7546 79.3377L96.7588 79.3334Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0982 125.347L74.0602 124.924L81.6592 124.222L87.5812 109.187L92.008 93.2267L90.4282 88.9057L77.3338 97.5647C77.2747 97.6027 77.1986 97.6112 77.1353 97.5816L61.6797 90.9182L61.8486 90.5293L77.1986 97.1503L90.4197 88.4068C90.4746 88.373 90.5422 88.3603 90.6014 88.3814C90.6647 88.4026 90.7112 88.4491 90.7323 88.5083L92.4261 93.1464C92.443 93.1887 92.443 93.2352 92.4304 93.2775L87.9783 109.327L82.0013 124.506C81.9717 124.582 81.9042 124.632 81.8239 124.637L74.0982 125.351V125.347Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4235 93.2888L92.0264 93.1493L95.6337 82.9598L94.3285 67.3796L93.885 39.7453L83.4348 39.3056L67.9539 35.6103L52.5152 37.3438L52.4688 36.9252L67.9455 35.1875C67.9708 35.1875 67.9961 35.1875 68.0173 35.1917L83.4897 38.8912L94.1004 39.3309C94.2102 39.3352 94.3032 39.4282 94.3032 39.5381L94.7467 67.3584L96.0519 82.9682C96.0519 82.9978 96.0519 83.0274 96.0392 83.057L92.415 93.2888H92.4235Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8244 57.943L64.4062 57.8795L67.7643 35.3908L66.0874 18.0306L66.5098 17.9883L68.1909 35.3739C68.1909 35.3739 68.1909 35.4077 68.1909 35.4246L64.8286 57.9387L64.8244 57.943Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9523 39.6945L81.8759 27.742L73.7109 16.7534L74.0489 16.5039L82.1927 27.4629L94.248 39.3943L93.9523 39.6945Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4327 108.819H77.0103V97.8055L70.2646 102.837L60.8957 108.731L60.6719 108.371L70.0238 102.486L77.0905 97.2136C77.1539 97.1671 77.2384 97.1586 77.3102 97.1925C77.382 97.2263 77.4285 97.3024 77.4285 97.3827V108.819H77.4327Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.539 88.7942C90.539 88.7942 90.5053 88.7943 90.4884 88.79L81.8461 86.6507L63.4844 80.761L63.6111 80.3594L81.9601 86.2448L90.4672 88.3503L95.7008 82.8412L96.0049 83.1329L90.6869 88.7308C90.6446 88.7731 90.5897 88.7985 90.5348 88.7985L90.539 88.7942Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.412 97.4676L77.0234 97.3027L81.6909 86.3776L83.6255 76.0781L84.0395 76.1542L82.1007 86.4748C82.1007 86.4748 82.0922 86.5044 82.088 86.5171L77.412 97.4634V97.4676Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1088 71.8502C71.0813 71.8502 69.4297 70.1971 69.4297 68.1676C69.4297 67.2037 69.7972 66.2904 70.4688 65.6055L70.7687 65.9014C70.1773 66.5103 69.8521 67.3136 69.8521 68.1676C69.8521 69.9645 71.3136 71.4274 73.1088 71.4274C74.904 71.4274 76.3655 69.9645 76.3655 68.1676C76.3655 67.3136 76.0402 66.506 75.4447 65.9014L75.7446 65.6055C76.4162 66.2946 76.7837 67.2037 76.7837 68.1676C76.7837 70.1971 75.1321 71.8502 73.1046 71.8502H73.1088Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5727 68.1667C74.5727 68.9784 73.9138 69.638 73.1028 69.638C72.2918 69.638 71.6328 68.9784 71.6328 68.1667C71.6328 67.3549 72.2918 66.6953 73.1028 66.6953C73.9138 66.6953 74.5727 67.3549 74.5727 68.1667Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.103 69.8499C72.1738 69.8499 71.4219 69.0931 71.4219 68.1671C71.4219 67.2412 72.178 66.4844 73.103 66.4844C74.0281 66.4844 74.7842 67.2412 74.7842 68.1671C74.7842 69.0931 74.0281 69.8499 73.103 69.8499ZM73.103 66.9072C72.4103 66.9072 71.8443 67.4737 71.8443 68.1671C71.8443 68.8605 72.4103 69.4271 73.103 69.4271C73.7958 69.4271 74.3618 68.8605 74.3618 68.1671C74.3618 67.4737 73.7958 66.9072 73.103 66.9072Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5475 67.5715C94.5475 67.5715 94.518 67.5715 94.5011 67.5672L91.3373 66.8527C91.2359 66.8273 91.1641 66.7343 91.1725 66.6286L91.6625 61.1914L92.0849 61.2295L91.6118 66.4849L94.4757 67.1318L98.1717 63.2716L98.4758 63.5633L94.6996 67.5081C94.6573 67.5503 94.6024 67.5715 94.5475 67.5715Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4993 136.76H44.2161C44.178 136.76 44.1442 136.751 44.1105 136.73L23.0877 124.604C23.0581 124.587 23.0285 124.562 23.0116 124.528L13.9258 109.193C13.9258 109.193 13.9047 109.151 13.9005 109.126L2.85473 50.9947C2.85051 50.9693 2.85051 50.9439 2.85473 50.9186L8.37549 20.9589C8.38394 20.9166 8.40506 20.8786 8.43462 20.849L20.4139 8.65118C20.4139 8.65118 20.4392 8.62581 20.4561 8.61736L33.5969 0.791315C33.6307 0.770175 33.6688 0.761719 33.7068 0.761719H52.5035V1.18452H33.7659L20.7011 8.96828L8.78521 21.0984L3.27713 50.9524L14.3102 109.011L23.3495 124.266L44.2752 136.337H52.5035V136.76H52.4993Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5775 72.2957C26.5395 72.2957 26.5057 72.2873 26.4719 72.2661L21.6607 69.501C21.6016 69.4672 21.5594 69.4038 21.5551 69.3361C21.5509 69.2685 21.5763 69.2008 21.6312 69.1543L25.9059 65.5859C25.9439 65.5563 25.9903 65.5352 26.041 65.5352H35.3042C35.338 65.5352 35.3718 65.5436 35.4014 65.5563L41.5473 68.6766C41.6191 68.7146 41.6656 68.7865 41.6613 68.8668C41.6613 68.9472 41.6149 69.019 41.5388 69.0529L35.6591 71.818C35.6337 71.8307 35.6084 71.8349 35.5788 71.8391L26.5817 72.2831H26.5732L26.5775 72.2957ZM22.1338 69.2896L26.6282 71.8729L35.5197 71.4332L40.9686 68.8711L35.2535 65.9706H26.1171L22.1338 69.2939V69.2896Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2418 90.932C43.2122 90.932 43.1869 90.9278 43.1573 90.9151C43.0897 90.8855 43.0433 90.8263 43.0306 90.7587L41.2481 80.5946C41.2439 80.565 41.2481 80.5354 41.2481 80.51L43.9768 69.0183L35.7484 63.6276L35.5161 65.7796L35.0979 65.7331L35.3641 63.2386C35.3725 63.1667 35.419 63.1033 35.4823 63.0695C35.5499 63.0399 35.6259 63.0441 35.6893 63.0821L44.3274 68.7435C44.4034 68.7942 44.4372 68.883 44.4161 68.9675L41.6663 80.5607L43.3854 90.3613L47.9262 87.3044L48.3655 68.0543L40.2639 58.0973L22.7935 54.123L13.2515 61.374C13.1881 61.4205 13.1121 61.429 13.0403 61.3994C12.9685 61.3698 12.922 61.3022 12.9135 61.2261L10.6875 39.5617C10.6875 39.5406 10.6875 39.5152 10.6875 39.4941L13.7161 25.4952C13.7288 25.4317 13.771 25.381 13.8259 25.3514L31.0176 16.4345C31.0598 16.4134 31.1063 16.4049 31.1527 16.4134L38.7052 17.7917L52.4712 16.4134L52.5135 16.8362L38.7179 18.2188C38.7179 18.2188 38.6799 18.2188 38.6588 18.2188L31.1443 16.8489L14.1047 25.6854L11.1057 39.5533L13.2895 60.8117L22.6118 53.7298C22.6625 53.6917 22.7259 53.6791 22.785 53.6917L40.4202 57.7041C40.4666 57.7126 40.5089 57.7422 40.5385 57.776L48.733 67.8513C48.7668 67.8894 48.7837 67.9401 48.7795 67.9909L48.3359 87.427C48.3359 87.4947 48.2979 87.5581 48.243 87.5961L43.3432 90.894C43.3094 90.9194 43.2672 90.9278 43.2249 90.9278L43.2418 90.932Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9997 16.7992L20.444 8.97318C20.3806 8.92667 20.3468 8.84634 20.3637 8.766C20.3764 8.68567 20.4355 8.62225 20.5115 8.60111L41.4034 2.25064C41.4034 2.25064 41.4457 2.24219 41.4668 2.24219H52.5125V2.66499H41.4963L21.0395 8.88439L31.2574 16.461L31.0039 16.7992H30.9997Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1206 16.8363C31.053 16.8363 30.9897 16.8067 30.9474 16.7475C30.8925 16.6714 30.8925 16.5741 30.9474 16.498L41.085 2.59635L33.6635 1.17997L33.7437 0.765625L41.4947 2.24543C41.5243 2.24966 41.5497 2.26234 41.5708 2.27502L52.6165 9.49646C52.6841 9.53874 52.7221 9.61907 52.7094 9.69941C52.6968 9.77974 52.6419 9.84739 52.5658 9.87276L31.1882 16.8278C31.1671 16.8363 31.146 16.8363 31.1248 16.8363H31.1206ZM41.5032 2.73588L31.674 16.2232L52.0125 9.60639L41.5032 2.73588Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8381 65.7918L25.3988 63.3354L21.5972 57.4457C21.5634 57.395 21.555 57.3316 21.5718 57.2724L22.5391 53.8773L21.3438 39.1173C21.3438 39.1173 21.3438 39.0877 21.3438 39.075L22.7715 27.5664L23.1896 27.6171L21.7661 39.1046L22.9615 53.8815C22.9615 53.9069 22.9615 53.9323 22.9531 53.9576L21.9985 57.2978L25.7705 63.1409C25.7874 63.1662 25.7958 63.1916 25.8001 63.217L26.2478 65.7157L25.8339 65.7918H25.8381Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7641 69.535C21.743 69.535 21.7219 69.535 21.6965 69.5266L13.5442 66.8503C13.4766 66.8291 13.426 66.7742 13.4048 66.7065C13.3879 66.6389 13.4048 66.5628 13.4513 66.512L21.6036 57.1935C21.6543 57.1385 21.7261 57.1089 21.8021 57.1258L37.9716 60.0685C38.0265 60.077 38.073 60.1066 38.1025 60.1531L44.3836 68.8036C44.4301 68.867 44.4385 68.9558 44.4005 69.0235C44.3625 69.0953 44.2864 69.1376 44.2104 69.1376L41.4479 69.0911C41.393 69.0911 41.3423 69.07 41.3043 69.0319L35.4879 63.4721H25.7136L21.9458 69.4378C21.9077 69.5012 21.8402 69.535 21.7683 69.535H21.7641ZM13.9835 66.5458L21.6754 69.07L25.4179 63.1465C25.4559 63.0831 25.5235 63.0493 25.5953 63.0493H35.5724C35.6273 63.0493 35.678 63.0704 35.7202 63.1085L41.5409 68.6683L43.7965 68.7064L37.8153 60.4702L21.8486 57.5656L13.9878 66.5501L13.9835 66.5458Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2216 69.1336C44.1329 69.1336 44.0526 69.0786 44.023 68.9898L40.3017 58.2887L38.0883 60.4239L37.7969 60.1195L40.2468 57.756C40.2975 57.7053 40.3735 57.6841 40.4411 57.701C40.5129 57.718 40.5678 57.7687 40.5932 57.8363L44.361 68.6727L48.5427 67.7764C48.5427 67.7764 48.5723 67.7722 48.585 67.7722H52.5048V68.195H48.6061L44.2638 69.1251C44.2638 69.1251 44.2342 69.1294 44.2216 69.1294V69.1336Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7814 71.6356L35.3594 71.6523L35.5369 76.1347L35.959 76.118L35.7814 71.6356Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4561 71.9149L21.0469 75.9492L21.2993 76.2883L26.7085 72.254L26.4561 71.9149Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9982 108.799L27.5781 108.844L28.7149 119.544L29.1349 119.499L27.9982 108.799Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4994 99.4477H48.1783C48.0347 99.4477 45.7453 98.6021 41.3776 96.9363C41.3016 96.9067 41.2467 96.8348 41.2425 96.7502C41.2383 96.6657 41.2805 96.5896 41.3523 96.5515L46.6069 93.7441C46.6661 93.7103 46.7421 93.7103 46.8013 93.7441L49.8721 95.3254H52.4952V95.7482H49.8214C49.7876 95.7482 49.7538 95.7397 49.7243 95.7228L46.7041 94.1669L41.9563 96.7037C44.4823 97.6635 47.9502 98.9699 48.2036 99.0249H52.4952V99.4435L52.4994 99.4477Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3396 99.381L48.0312 99.0935L49.2351 97.8039L49.6237 95.5039L50.0419 95.5758L49.6406 97.9392C49.6321 97.9815 49.6152 98.0196 49.5857 98.0492L48.3396 99.3852V99.381Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4967 93.9195L46.4531 96.7266L46.8755 96.7331L46.919 93.9261L46.4967 93.9195Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.498 98.1135H49.423C49.3934 98.1135 49.368 98.1093 49.3427 98.0966L46.6224 96.9551H41.4523C41.3847 96.9551 41.3213 96.9255 41.2833 96.8705C41.2453 96.8155 41.2326 96.7479 41.2495 96.6845L43.0321 90.668L47.9741 68.0312L48.3881 68.12L43.446 90.7695L41.7395 96.5323H46.6689C46.6985 96.5323 46.7238 96.5365 46.7492 96.5492L49.4694 97.6907H52.498V98.1135Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1932 124.634C23.1552 124.634 23.113 124.621 23.0792 124.6C22.9989 124.549 22.9651 124.452 22.9905 124.363L27.5482 108.855L14.2848 88.6957C14.2637 88.6618 14.251 88.6238 14.251 88.5857L13.4062 66.6508C13.4062 66.5578 13.4569 66.4775 13.5456 66.4436C13.6301 66.4098 13.7273 66.4394 13.7822 66.5113L21.2671 75.9059H35.6751L44.0767 68.7564L44.3512 69.0777L35.8906 76.278C35.8525 76.3118 35.8019 76.3287 35.7554 76.3287H21.1699C21.1066 76.3287 21.0432 76.2991 21.0052 76.2484L13.8582 67.2766L14.6777 88.5096L27.9621 108.698C27.9959 108.749 28.0044 108.817 27.9875 108.876L23.603 123.797L28.7436 119.391L34.6698 102.593C34.6825 102.559 34.7036 102.53 34.729 102.509L41.3226 96.5809L41.6056 96.8938L35.0542 102.788L29.1279 119.59C29.1153 119.624 29.0942 119.657 29.0646 119.679L23.3411 124.583C23.3031 124.617 23.2524 124.634 23.2017 124.634H23.1932Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4725 120.043L44.1893 119.109C44.147 119.105 44.1048 119.084 44.071 119.058L37.2112 112.907C37.131 112.835 37.1183 112.716 37.1775 112.628C37.2366 112.539 37.3549 112.509 37.4478 112.56L43.7373 115.799L52.519 116.864L52.4683 117.283L43.6486 116.213C43.6233 116.213 43.5979 116.204 43.5768 116.192L38.7108 113.689L44.2949 118.699L52.5105 119.629L52.4641 120.048L52.4725 120.043Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8841 115.962L43.4688 116.039L44.0033 118.937L44.4186 118.86L43.8841 115.962Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9449 113.645L30.8984 113.227L37.2851 112.542L44.1026 108.377C44.1364 108.356 44.1744 108.348 44.2125 108.348H50.2232C50.2697 108.348 50.3161 108.365 50.3541 108.394L52.6266 110.221C52.7027 110.284 52.728 110.39 52.6816 110.479C52.6393 110.567 52.5379 110.614 52.4408 110.588L49.7966 109.925L43.5028 110.056L38.2904 112.533H52.4957V112.956H37.3654L30.9407 113.645H30.9449ZM44.2758 108.766L40.8966 110.829L43.3677 109.654C43.393 109.641 43.4226 109.633 43.4521 109.633L49.8219 109.498C49.8219 109.498 49.8599 109.498 49.8768 109.502L51.6171 109.937L50.1556 108.758H44.2758V108.766Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3517 99.2377L50.0234 108.555L50.4456 108.57L50.7739 99.2526L50.3517 99.2377Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1257 108.875L14.1016 109.297L17.218 109.475L17.2421 109.053L14.1257 108.875Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6006 96.3749L9.09578 95.7407C9.03664 95.7281 8.99018 95.69 8.96061 95.635L1.80517 82.1731C1.7925 82.1519 1.78405 82.1266 1.78405 82.1012L0.00152351 67.6541C-0.00270048 67.616 0.00152351 67.5738 0.0184195 67.5399L2.42187 62.3691C2.46833 62.2718 2.57393 62.2253 2.67531 62.2549L5.47159 63.1259L5.34487 63.5276L2.726 62.7115L0.423923 67.6625L2.19378 82.0082L9.28586 95.356L11.702 95.9691L11.6006 96.3792V96.3749Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80889 90.0421C7.73286 90.0421 7.66105 89.9998 7.62303 89.9322L3.94816 83.087C3.93549 83.0617 3.92704 83.0321 3.92281 83.0025L3.0569 70.365L2.20365 82.0892L1.78125 82.0596L2.84992 67.3462C2.85837 67.2489 2.93018 67.1686 3.0231 67.1517C3.11603 67.1348 3.21318 67.1855 3.2512 67.2743L8.64101 79.2269C8.66636 79.2861 8.66636 79.3579 8.63257 79.4171L6.62617 83.0152L7.78777 88.0127L10.4911 89.3614C10.5756 89.4037 10.6221 89.4967 10.6052 89.5897C10.5883 89.6827 10.5122 89.7504 10.4193 89.7631L7.83001 90.0421C7.83001 90.0421 7.81311 90.0421 7.80889 90.0421ZM4.34099 82.9264L7.92716 89.6066L9.659 89.4206L7.51321 88.3467C7.4583 88.3171 7.41606 88.2663 7.40338 88.2071L6.19955 83.0321C6.18687 82.9813 6.19532 82.9264 6.22067 82.8799L8.21862 79.303L3.3568 68.5215L4.34099 82.9264Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.233328 67.8409L0.195312 67.4181L2.83531 67.1686L2.40868 62.4756L2.83108 62.4375L3.2746 67.342C3.28305 67.4561 3.19857 67.5618 3.08452 67.5703L0.233328 67.8367V67.8409Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.014 136.594L42.7468 130.51C42.7341 130.447 42.7468 130.379 42.7933 130.332L45.7332 126.81C45.7712 126.764 45.8346 126.734 45.8937 126.734H52.5085V127.157H45.9951L43.1861 130.523L44.4364 136.51L44.0225 136.598L44.014 136.594Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9452 130.674C42.9156 130.674 42.886 130.67 42.8607 130.658L30.835 125.33C30.7801 125.305 30.742 125.263 30.7209 125.208L28.7188 119.589L29.1158 119.445L31.0884 124.975L42.603 130.078L37.1541 112.803L37.5553 112.676L43.1437 130.395C43.169 130.476 43.1437 130.56 43.0845 130.615C43.0465 130.649 42.9958 130.67 42.9452 130.67V130.674Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2955 121.456L40.0078 121.766L45.7418 127.105L46.0295 126.795L40.2955 121.456Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14552 51.1475L2.97656 50.7585L6.81617 49.0969L10.7022 39.457L11.0951 39.6135L7.17521 49.3337C7.15409 49.3844 7.11607 49.4267 7.06116 49.4478L3.1413 51.1432L3.14552 51.1475Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24642 79.3334L6.47656 63.4361L6.77647 49.2554L8.38158 20.9827C8.38581 20.9024 8.43649 20.8305 8.5083 20.8009C8.58011 20.7713 8.66881 20.784 8.72795 20.8347L14.0713 25.3798L13.7967 25.7011L8.77441 21.4309L7.19464 49.2723L6.89474 63.4192L8.66459 79.2911L8.24642 79.3377V79.3334Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9023 125.348L23.1766 124.634C23.0963 124.625 23.0288 124.574 22.9992 124.503L17.0307 109.345L12.5702 93.2745C12.5575 93.2323 12.5617 93.1858 12.5744 93.1435L14.2682 88.5054C14.2893 88.4462 14.34 88.3997 14.3991 88.3785C14.4583 88.3574 14.5259 88.3658 14.5808 88.4039L27.8019 97.1474L43.1519 90.5263L43.3208 90.9153L27.8652 97.5787C27.7976 97.6083 27.7258 97.5998 27.6667 97.5617L14.5723 88.9028L12.9926 93.2238L17.4277 109.206L23.3413 124.219L30.9403 124.921L30.9023 125.344V125.348Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5744 93.2863L8.95017 83.0545C8.94172 83.0249 8.9375 82.9953 8.9375 82.9657L10.2469 67.3433L10.6905 39.5399C10.6905 39.4257 10.7792 39.3369 10.8932 39.3327L21.5419 38.8888L36.9764 35.1935C37.0017 35.1892 37.0228 35.185 37.0482 35.1893L52.5249 36.927L52.4784 37.3455L37.0397 35.6121L21.601 39.3031L11.1086 39.747L10.6651 67.3644L9.3599 82.9573L12.9672 93.1468L12.5701 93.2863H12.5744Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1748 57.9426L36.8125 35.4285C36.8125 35.4285 36.8125 35.3947 36.8125 35.3778L38.4936 17.9922L38.916 18.0345L37.2391 35.3947L40.5972 57.8834L40.179 57.9469L40.1748 57.9426Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0499 39.6945L10.75 39.3943L22.8306 27.4418L30.9491 16.5039L31.2913 16.7534L23.1474 27.7166L11.0499 39.6945Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9927 108.821H27.5703V97.384C27.5703 97.3037 27.6168 97.2318 27.6886 97.1937C27.7604 97.1599 27.8449 97.1641 27.9082 97.2149L34.9919 102.5L44.3311 108.377L44.1072 108.736L34.7553 102.851L27.9969 97.811V108.825L27.9927 108.821Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4623 88.7946C14.4073 88.7946 14.3482 88.7734 14.3102 88.7269L8.99219 83.129L9.29631 82.8373L14.5298 88.3464L23.0496 86.2366L41.386 80.3555L41.5127 80.7571L23.1637 86.6425L14.5087 88.7861C14.5087 88.7861 14.4749 88.7903 14.458 88.7903L14.4623 88.7946Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5884 97.4673L22.9124 86.521C22.9124 86.521 22.904 86.4914 22.8998 86.4787L20.9609 76.1581L21.3749 76.082L23.3095 86.3815L27.977 97.3066L27.5884 97.4715V97.4673Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8978 71.8502C29.8703 71.8502 28.2188 70.1971 28.2188 68.1676C28.2188 67.2037 28.5862 66.2904 29.2579 65.6055L29.5578 65.9014C28.9664 66.5103 28.6369 67.3136 28.6369 68.1676C28.6369 69.9645 30.0984 71.4274 31.8936 71.4274C33.6888 71.4274 35.1503 69.9645 35.1503 68.1676C35.1503 67.3136 34.8251 66.506 34.2337 65.9014L34.5336 65.6055C35.2052 66.2946 35.5727 67.2037 35.5727 68.1676C35.5727 70.1971 33.9211 71.8502 31.8936 71.8502H31.8978Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4219 68.1667C30.4219 68.9784 31.0808 69.638 31.8918 69.638C32.7028 69.638 33.3618 68.9784 33.3618 68.1667C33.3618 67.3549 32.7028 66.6953 31.8918 66.6953C31.0808 66.6953 30.4219 67.3549 30.4219 68.1667Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8921 69.8499C30.9628 69.8499 30.2109 69.0931 30.2109 68.1671C30.2109 67.2412 30.967 66.4844 31.8921 66.4844C32.8171 66.4844 33.5732 67.2412 33.5732 68.1671C33.5732 69.0931 32.8171 69.8499 31.8921 69.8499ZM31.8921 66.9072C31.1994 66.9072 30.6333 67.4737 30.6333 68.1671C30.6333 68.8605 31.1994 69.4271 31.8921 69.4271C32.5848 69.4271 33.1508 68.8605 33.1508 68.1671C33.1508 67.4737 32.5848 66.9072 31.8921 66.9072Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4596 67.5715C10.4047 67.5715 10.3455 67.5503 10.3075 67.5081L6.53125 63.5633L6.83538 63.2716L10.5314 67.1318L13.3952 66.4849L12.9222 61.2295L13.3446 61.1914L13.8345 66.6286C13.843 66.7343 13.7754 66.8316 13.6698 66.8527L10.506 67.5672C10.506 67.5672 10.4765 67.5715 10.4596 67.5715Z",
    fill: "white",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3677 27.5884C84.3677 28.8822 83.3201 29.9307 82.0276 29.9307C80.735 29.9307 79.6875 28.8822 79.6875 27.5884C79.6875 26.2946 80.735 25.2461 82.0276 25.2461C83.3201 25.2461 84.3677 26.2946 84.3677 27.5884Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2825 27.5878C83.2825 28.2811 82.7207 28.8435 82.028 28.8435C81.3352 28.8435 80.7734 28.2811 80.7734 27.5878C80.7734 26.8944 81.3352 26.332 82.028 26.332C82.7207 26.332 83.2825 26.8944 83.2825 27.5878Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.301 20.3487C67.5934 20.3487 68.6411 19.3 68.6411 18.0064C68.6411 16.7128 67.5934 15.6641 66.301 15.6641C65.0086 15.6641 63.9609 16.7128 63.9609 18.0064C63.9609 19.3 65.0086 20.3487 66.301 20.3487Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5559 18.0057C67.5559 18.6991 66.9941 19.2614 66.3014 19.2614C65.6087 19.2614 65.0469 18.6991 65.0469 18.0057C65.0469 17.3123 65.6087 16.75 66.3014 16.75C66.9941 16.75 67.5559 17.3123 67.5559 18.0057Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3208 35.397C70.3208 36.6908 69.2733 37.7393 67.9807 37.7393C66.6882 37.7393 65.6406 36.6908 65.6406 35.397C65.6406 34.1032 66.6882 33.0547 67.9807 33.0547C69.2733 33.0547 70.3208 34.1032 70.3208 35.397Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2278 35.3963C69.2278 36.0897 68.666 36.6521 67.9733 36.6521C67.2805 36.6521 66.7188 36.0897 66.7188 35.3963C66.7188 34.703 67.2805 34.1406 67.9733 34.1406C68.666 34.1406 69.2278 34.703 69.2278 35.3963Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2271 16.6275C76.2271 17.9212 75.1795 18.9698 73.887 18.9698C72.5944 18.9698 71.5469 17.9212 71.5469 16.6275C71.5469 15.3337 72.5944 14.2852 73.887 14.2852C75.1795 14.2852 76.2271 15.3337 76.2271 16.6275Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1341 16.6268C75.1341 17.3202 74.5723 17.8825 73.8795 17.8825C73.1868 17.8825 72.625 17.3202 72.625 16.6268C72.625 15.9334 73.1868 15.3711 73.8795 15.3711C74.5723 15.3711 75.1341 15.9334 75.1341 16.6268Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.551 4.7901C64.8434 4.7901 65.8911 3.74141 65.8911 2.44779C65.8911 1.15416 64.8434 0.105469 63.551 0.105469C62.2586 0.105469 61.2109 1.15416 61.2109 2.44779C61.2109 3.74141 62.2586 4.7901 63.551 4.7901Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8059 2.44712C64.8059 3.14052 64.2441 3.70284 63.5514 3.70284C62.8587 3.70284 62.2969 3.14052 62.2969 2.44712C62.2969 1.75373 62.8587 1.19141 63.5514 1.19141C64.2441 1.19141 64.8059 1.75373 64.8059 2.44712Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4495 41.4385C84.7419 41.4385 85.7896 40.3898 85.7896 39.0962C85.7896 37.8026 84.7419 36.7539 83.4495 36.7539C82.1571 36.7539 81.1094 37.8026 81.1094 39.0962C81.1094 40.3898 82.1571 41.4385 83.4495 41.4385Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7044 39.0956C84.7044 39.789 84.1426 40.3513 83.4498 40.3513C82.7571 40.3513 82.1953 39.789 82.1953 39.0956C82.1953 38.4022 82.7571 37.8398 83.4498 37.8398C84.1426 37.8398 84.7044 38.4022 84.7044 39.0956Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0979 41.8839C95.3903 41.8839 96.438 40.8352 96.438 39.5415C96.438 38.2479 95.3903 37.1992 94.0979 37.1992C92.8055 37.1992 91.7578 38.2479 91.7578 39.5415C91.7578 40.8352 92.8055 41.8839 94.0979 41.8839Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3528 39.5409C95.3528 40.2343 94.791 40.7966 94.0983 40.7966C93.4055 40.7966 92.8438 40.2343 92.8438 39.5409C92.8438 38.8475 93.4055 38.2852 94.0983 38.2852C94.791 38.2852 95.3528 38.8475 95.3528 39.5409Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.36 49.2603C100.36 50.5541 99.3123 51.6026 98.0198 51.6026C96.7272 51.6026 95.6797 50.5541 95.6797 49.2603C95.6797 47.9665 96.7272 46.918 98.0198 46.918C99.3123 46.918 100.36 47.9665 100.36 49.2603Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2747 49.2596C99.2747 49.953 98.7129 50.5153 98.0202 50.5153C97.3274 50.5153 96.7656 49.953 96.7656 49.2596C96.7656 48.5662 97.3274 48.0039 98.0202 48.0039C98.7129 48.0039 99.2747 48.5662 99.2747 49.2596Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.942 69.7042C103.234 69.7042 104.282 68.6555 104.282 67.3619C104.282 66.0682 103.234 65.0195 101.942 65.0195C100.649 65.0195 99.6016 66.0682 99.6016 67.3619C99.6016 68.6555 100.649 69.7042 101.942 69.7042Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.197 67.3612C103.197 68.0546 102.635 68.6169 101.942 68.6169C101.249 68.6169 100.688 68.0546 100.688 67.3612C100.688 66.6678 101.249 66.1055 101.942 66.1055C102.635 66.1055 103.197 66.6678 103.197 67.3612Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.946 82.9829C100.946 84.2767 99.8983 85.3253 98.6057 85.3253C97.3132 85.3253 96.2656 84.2767 96.2656 82.9829C96.2656 81.6892 97.3132 80.6406 98.6057 80.6406C99.8983 80.6406 100.946 81.6892 100.946 82.9829Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8528 82.9823C99.8528 83.6757 99.291 84.238 98.5983 84.238C97.9055 84.238 97.3438 83.6757 97.3438 82.9823C97.3438 82.2889 97.9055 81.7266 98.5983 81.7266C99.291 81.7266 99.8528 82.2889 99.8528 82.9823Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5942 53.8931C84.5942 55.1869 83.5467 56.2354 82.2542 56.2354C80.9616 56.2354 79.9141 55.1869 79.9141 53.8931C79.9141 52.5993 80.9616 51.5508 82.2542 51.5508C83.5467 51.5508 84.5942 52.5993 84.5942 53.8931Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5012 53.8924C83.5012 54.5858 82.9394 55.1482 82.2467 55.1482C81.554 55.1482 80.9922 54.5858 80.9922 53.8924C80.9922 53.199 81.554 52.6367 82.2467 52.6367C82.9394 52.6367 83.5012 53.199 83.5012 53.8924Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5786 69.3228C85.5786 70.6166 84.5311 71.6651 83.2385 71.6651C81.946 71.6651 80.8984 70.6166 80.8984 69.3228C80.8984 68.029 81.946 66.9805 83.2385 66.9805C84.5311 66.9805 85.5786 68.029 85.5786 69.3228Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4856 69.3221C84.4856 70.0155 83.9238 70.5778 83.2311 70.5778C82.5383 70.5778 81.9766 70.0155 81.9766 69.3221C81.9766 68.6287 82.5383 68.0664 83.2311 68.0664C83.9238 68.0664 84.4856 68.6287 84.4856 69.3221Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.426 65.6026C70.7184 65.6026 71.7661 64.5539 71.7661 63.2603C71.7661 61.9667 70.7184 60.918 69.426 60.918C68.1336 60.918 67.0859 61.9667 67.0859 63.2603C67.0859 64.5539 68.1336 65.6026 69.426 65.6026Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6809 63.2596C70.6809 63.953 70.1191 64.5153 69.4264 64.5153C68.7337 64.5153 68.1719 63.953 68.1719 63.2596C68.1719 62.5662 68.7337 62.0039 69.4264 62.0039C70.1191 62.0039 70.6809 62.5662 70.6809 63.2596Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8401 78.462C85.1325 78.462 86.1802 77.4133 86.1802 76.1197C86.1802 74.826 85.1325 73.7773 83.8401 73.7773C82.5477 73.7773 81.5 74.826 81.5 76.1197C81.5 77.4133 82.5477 78.462 83.8401 78.462Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.095 76.119C85.095 76.8124 84.5332 77.3747 83.8405 77.3747C83.1477 77.3747 82.5859 76.8124 82.5859 76.119C82.5859 75.4256 83.1477 74.8633 83.8405 74.8633C84.5332 74.8633 85.095 75.4256 85.095 76.119Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.551 82.9815C64.8434 82.9815 65.8911 81.9328 65.8911 80.6392C65.8911 79.3456 64.8434 78.2969 63.551 78.2969C62.2586 78.2969 61.2109 79.3456 61.2109 80.6392C61.2109 81.9328 62.2586 82.9815 63.551 82.9815Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8059 80.6385C64.8059 81.3319 64.2441 81.8943 63.5514 81.8943C62.8587 81.8943 62.2969 81.3319 62.2969 80.6385C62.2969 79.9451 62.8587 79.3828 63.5514 79.3828C64.2441 79.3828 64.8059 79.9451 64.8059 80.6385Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7271 66.647C93.7271 67.9408 92.6795 68.9893 91.387 68.9893C90.0944 68.9893 89.0469 67.9408 89.0469 66.647C89.0469 65.3532 90.0944 64.3047 91.387 64.3047C92.6795 64.3047 93.7271 65.3532 93.7271 66.647Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6419 66.6463C92.6419 67.3397 92.0801 67.9021 91.3873 67.9021C90.6946 67.9021 90.1328 67.3397 90.1328 66.6463C90.1328 65.953 90.6946 65.3906 91.3873 65.3906C92.0801 65.3906 92.6419 65.953 92.6419 66.6463Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1099 90.7212C64.1099 92.015 63.0623 93.0635 61.7698 93.0635C60.4772 93.0635 59.4297 92.015 59.4297 90.7212C59.4297 89.4275 60.4772 88.3789 61.7698 88.3789C63.0623 88.3789 64.1099 89.4275 64.1099 90.7212Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0169 90.7206C63.0169 91.414 62.4551 91.9763 61.7623 91.9763C61.0696 91.9763 60.5078 91.414 60.5078 90.7206C60.5078 90.0272 61.0696 89.4648 61.7623 89.4648C62.4551 89.4648 63.0169 90.0272 63.0169 90.7206Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8911 96.7369C65.8911 98.0306 64.8436 99.0792 63.551 99.0792C62.2585 99.0792 61.2109 98.0306 61.2109 96.7369C61.2109 95.4431 62.2585 94.3945 63.551 94.3945C64.8436 94.3945 65.8911 95.4431 65.8911 96.7369Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8059 96.7362C64.8059 97.4296 64.2441 97.9919 63.5514 97.9919C62.8587 97.9919 62.2969 97.4296 62.2969 96.7362C62.2969 96.0428 62.8587 95.4805 63.5514 95.4805C64.2441 95.4805 64.8059 96.0428 64.8059 96.7362Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5745 100.243C56.8669 100.243 57.9146 99.1945 57.9146 97.9009C57.9146 96.6073 56.8669 95.5586 55.5745 95.5586C54.2821 95.5586 53.2344 96.6073 53.2344 97.9009C53.2344 99.1945 54.2821 100.243 55.5745 100.243Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8294 97.9003C56.8294 98.5936 56.2676 99.156 55.5748 99.156C54.8821 99.156 54.3203 98.5936 54.3203 97.9003C54.3203 97.2069 54.8821 96.6445 55.5748 96.6445C56.2676 96.6445 56.8294 97.2069 56.8294 97.9003Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.551 71.2159C64.8434 71.2159 65.8911 70.1672 65.8911 68.8736C65.8911 67.5799 64.8434 66.5312 63.551 66.5312C62.2586 66.5312 61.2109 67.5799 61.2109 68.8736C61.2109 70.1672 62.2586 71.2159 63.551 71.2159Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8059 68.8729C64.8059 69.5663 64.2441 70.1286 63.5514 70.1286C62.8587 70.1286 62.2969 69.5663 62.2969 68.8729C62.2969 68.1795 62.8587 67.6172 63.5514 67.6172C64.2441 67.6172 64.8059 68.1795 64.8059 68.8729Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8833 88.5806C92.8833 89.8744 91.8358 90.9229 90.5432 90.9229C89.2507 90.9229 88.2031 89.8744 88.2031 88.5806C88.2031 87.2868 89.2507 86.2383 90.5432 86.2383C91.8358 86.2383 92.8833 87.2868 92.8833 88.5806Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7903 88.5799C91.7903 89.2733 91.2285 89.8357 90.5358 89.8357C89.843 89.8357 89.2812 89.2733 89.2812 88.5799C89.2812 87.8865 89.843 87.3242 90.5358 87.3242C91.2285 87.3242 91.7903 87.8865 91.7903 88.5799Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.563 97.3853C79.563 98.6791 78.5154 99.7276 77.2229 99.7276C75.9304 99.7276 74.8828 98.6791 74.8828 97.3853C74.8828 96.0915 75.9304 95.043 77.2229 95.043C78.5154 95.043 79.563 96.0915 79.563 97.3853Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4778 97.3846C78.4778 98.078 77.916 98.6403 77.2233 98.6403C76.5305 98.6403 75.9688 98.078 75.9688 97.3846C75.9688 96.6912 76.5305 96.1289 77.2233 96.1289C77.916 96.1289 78.4778 96.6912 78.4778 97.3846Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9849 112.745C69.9849 114.038 68.9373 115.087 67.6448 115.087C66.3522 115.087 65.3047 114.038 65.3047 112.745C65.3047 111.451 66.3522 110.402 67.6448 110.402C68.9373 110.402 69.9849 111.451 69.9849 112.745Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8997 112.744C68.8997 113.437 68.3379 114 67.6452 114C66.9524 114 66.3906 113.437 66.3906 112.744C66.3906 112.051 66.9524 111.488 67.6452 111.488C68.3379 111.488 68.8997 112.051 68.8997 112.744Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8088 126.763C83.1012 126.763 84.1489 125.714 84.1489 124.42C84.1489 123.127 83.1012 122.078 81.8088 122.078C80.5164 122.078 79.4688 123.127 79.4688 124.42C79.4688 125.714 80.5164 126.763 81.8088 126.763Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8092 125.676C82.5021 125.676 83.0637 125.113 83.0637 124.42C83.0637 123.726 82.5021 123.164 81.8092 123.164C81.1164 123.164 80.5547 123.726 80.5547 124.42C80.5547 125.113 81.1164 125.676 81.8092 125.676Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1177 109.264C90.1177 110.558 89.0701 111.607 87.7776 111.607C86.4851 111.607 85.4375 110.558 85.4375 109.264C85.4375 107.97 86.4851 106.922 87.7776 106.922C89.0701 106.922 90.1177 107.97 90.1177 109.264Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0325 109.264C89.0325 109.957 88.4707 110.519 87.778 110.519C87.0852 110.519 86.5234 109.957 86.5234 109.264C86.5234 108.57 87.0852 108.008 87.778 108.008C88.4707 108.008 89.0325 108.57 89.0325 109.264Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4224 119.518C78.4224 120.812 77.3748 121.86 76.0823 121.86C74.7897 121.86 73.7422 120.812 73.7422 119.518C73.7422 118.224 74.7897 117.176 76.0823 117.176C77.3748 117.176 78.4224 118.224 78.4224 119.518Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3372 119.517C77.3372 120.211 76.7754 120.773 76.0827 120.773C75.3899 120.773 74.8281 120.211 74.8281 119.517C74.8281 118.824 75.3899 118.262 76.0827 118.262C76.7754 118.262 77.3372 118.824 77.3372 119.517Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4614 126.94C61.4614 128.234 60.4139 129.282 59.1213 129.282C57.8288 129.282 56.7812 128.234 56.7812 126.94C56.7812 125.646 57.8288 124.598 59.1213 124.598C60.4139 124.598 61.4614 125.646 61.4614 126.94Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3762 126.939C60.3762 127.633 59.8144 128.195 59.1217 128.195C58.429 128.195 57.8672 127.633 57.8672 126.939C57.8672 126.246 58.429 125.684 59.1217 125.684C59.8144 125.684 60.3762 126.246 60.3762 126.939Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1333 136.549C63.1333 137.843 62.0858 138.892 60.7932 138.892C59.5007 138.892 58.4531 137.843 58.4531 136.549C58.4531 135.256 59.5007 134.207 60.7932 134.207C62.0858 134.207 63.1333 135.256 63.1333 136.549Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0403 136.549C62.0403 137.242 61.4785 137.804 60.7858 137.804C60.093 137.804 59.5312 137.242 59.5312 136.549C59.5312 135.855 60.093 135.293 60.7858 135.293C61.4785 135.293 62.0403 135.855 62.0403 136.549Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6213 60.2471C65.9137 60.2471 66.9614 59.1984 66.9614 57.9048C66.9614 56.6112 65.9137 55.5625 64.6213 55.5625C63.3289 55.5625 62.2812 56.6112 62.2812 57.9048C62.2812 59.1984 63.3289 60.2471 64.6213 60.2471Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8762 57.9042C65.8762 58.5975 65.3144 59.1599 64.6217 59.1599C63.929 59.1599 63.3672 58.5975 63.3672 57.9042C63.3672 57.2108 63.929 56.6484 64.6217 56.6484C65.3144 56.6484 65.8762 57.2108 65.8762 57.9042Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1646 68.0689C59.1646 69.3626 58.117 70.4112 56.8245 70.4112C55.5319 70.4112 54.4844 69.3626 54.4844 68.0689C54.4844 66.7751 55.5319 65.7266 56.8245 65.7266C58.117 65.7266 59.1646 66.7751 59.1646 68.0689Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0794 68.0682C58.0794 68.7616 57.5176 69.3239 56.8248 69.3239C56.1321 69.3239 55.5703 68.7616 55.5703 68.0682C55.5703 67.3748 56.1321 66.8125 56.8248 66.8125C57.5176 66.8125 58.0794 67.3748 58.0794 68.0682Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0391 27.5884C21.0391 28.8822 22.0866 29.9307 23.3792 29.9307C24.6717 29.9307 25.7192 28.8822 25.7192 27.5884C25.7192 26.2946 24.6717 25.2461 23.3792 25.2461C22.0866 25.2461 21.0391 26.2946 21.0391 27.5884Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.125 27.5878C22.125 28.2811 22.6868 28.8435 23.3795 28.8435C24.0723 28.8435 24.6341 28.2811 24.6341 27.5878C24.6341 26.8944 24.0723 26.332 23.3795 26.332C22.6868 26.332 22.125 26.8944 22.125 27.5878Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1057 20.3487C40.3981 20.3487 41.4458 19.3 41.4458 18.0064C41.4458 16.7128 40.3981 15.6641 39.1057 15.6641C37.8133 15.6641 36.7656 16.7128 36.7656 18.0064C36.7656 19.3 37.8133 20.3487 39.1057 20.3487Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8516 18.0057C37.8516 18.6991 38.4134 19.2614 39.1061 19.2614C39.7988 19.2614 40.3606 18.6991 40.3606 18.0057C40.3606 17.3123 39.7988 16.75 39.1061 16.75C38.4134 16.75 37.8516 17.3123 37.8516 18.0057Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0859 35.397C35.0859 36.6908 36.1335 37.7393 37.426 37.7393C38.7186 37.7393 39.7661 36.6908 39.7661 35.397C39.7661 34.1032 38.7186 33.0547 37.426 33.0547C36.1335 33.0547 35.0859 34.1032 35.0859 35.397Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1719 35.3963C36.1719 36.0897 36.7337 36.6521 37.4264 36.6521C38.1191 36.6521 38.6809 36.0897 38.6809 35.3963C38.6809 34.703 38.1191 34.1406 37.4264 34.1406C36.7337 34.1406 36.1719 34.703 36.1719 35.3963Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1797 16.6275C29.1797 17.9212 30.2272 18.9698 31.5198 18.9698C32.8123 18.9698 33.8599 17.9212 33.8599 16.6275C33.8599 15.3337 32.8123 14.2852 31.5198 14.2852C30.2272 14.2852 29.1797 15.3337 29.1797 16.6275Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2656 16.6268C30.2656 17.3202 30.8274 17.8825 31.5201 17.8825C32.2129 17.8825 32.7747 17.3202 32.7747 16.6268C32.7747 15.9334 32.2129 15.3711 31.5201 15.3711C30.8274 15.3711 30.2656 15.9334 30.2656 16.6268Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5156 2.44779C39.5156 3.74156 40.5632 4.7901 41.8557 4.7901C43.1483 4.7901 44.1958 3.74156 44.1958 2.44779C44.1958 1.15401 43.1483 0.105469 41.8557 0.105469C40.5632 0.105469 39.5156 1.15401 39.5156 2.44779Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6016 2.44712C40.6016 3.14052 41.1634 3.70284 41.8561 3.70284C42.5488 3.70284 43.1106 3.14052 43.1106 2.44712C43.1106 1.75373 42.5488 1.19141 41.8561 1.19141C41.1634 1.19141 40.6016 1.75373 40.6016 2.44712Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6094 39.0962C19.6094 40.39 20.6569 41.4385 21.9495 41.4385C23.242 41.4385 24.2896 40.39 24.2896 39.0962C24.2896 37.8025 23.242 36.7539 21.9495 36.7539C20.6569 36.7539 19.6094 37.8025 19.6094 39.0962Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6953 39.0956C20.6953 39.789 21.2571 40.3513 21.9498 40.3513C22.6426 40.3513 23.2044 39.789 23.2044 39.0956C23.2044 38.4022 22.6426 37.8398 21.9498 37.8398C21.2571 37.8398 20.6953 38.4022 20.6953 39.0956Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.301 41.8839C12.5934 41.8839 13.6411 40.8352 13.6411 39.5415C13.6411 38.2479 12.5934 37.1992 11.301 37.1992C10.0086 37.1992 8.96094 38.2479 8.96094 39.5415C8.96094 40.8352 10.0086 41.8839 11.301 41.8839Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0469 39.5409C10.0469 40.2343 10.6087 40.7966 11.3014 40.7966C11.9941 40.7966 12.5559 40.2343 12.5559 39.5409C12.5559 38.8475 11.9941 38.2852 11.3014 38.2852C10.6087 38.2852 10.0469 38.8475 10.0469 39.5409Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38697 51.6026C8.67936 51.6026 9.72706 50.5539 9.72706 49.2603C9.72706 47.9667 8.67936 46.918 7.38697 46.918C6.09457 46.918 5.04688 47.9667 5.04688 49.2603C5.04688 50.5539 6.09457 51.6026 7.38697 51.6026Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13281 49.2596C6.13281 49.953 6.6946 50.5153 7.38734 50.5153C8.08007 50.5153 8.64186 49.953 8.64186 49.2596C8.64186 48.5662 8.08007 48.0039 7.38734 48.0039C6.6946 48.0039 6.13281 48.5662 6.13281 49.2596Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46509 69.7042C4.75749 69.7042 5.80518 68.6555 5.80518 67.3619C5.80518 66.0682 4.75749 65.0195 3.46509 65.0195C2.17269 65.0195 1.125 66.0682 1.125 67.3619C1.125 68.6555 2.17269 69.7042 3.46509 69.7042Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21094 67.3612C2.21094 68.0546 2.77273 68.6169 3.46546 68.6169C4.1582 68.6169 4.71999 68.0546 4.71999 67.3612C4.71999 66.6678 4.1582 66.1055 3.46546 66.1055C2.77273 66.1055 2.21094 66.6678 2.21094 67.3612Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46094 82.9829C4.46094 84.2767 5.50849 85.3253 6.80103 85.3253C8.09357 85.3253 9.14112 84.2767 9.14112 82.9829C9.14112 81.6892 8.09357 80.6406 6.80103 80.6406C5.50849 80.6406 4.46094 81.6892 4.46094 82.9829Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54688 82.9823C5.54688 83.6757 6.10867 84.238 6.8014 84.238C7.49414 84.238 8.05593 83.6757 8.05593 82.9823C8.05593 82.2889 7.49414 81.7266 6.8014 81.7266C6.10867 81.7266 5.54688 82.2889 5.54688 82.9823Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 53.8931C20.8125 55.1869 21.8601 56.2354 23.1526 56.2354C24.4451 56.2354 25.4927 55.1869 25.4927 53.8931C25.4927 52.5993 24.4451 51.5508 23.1526 51.5508C21.8601 51.5508 20.8125 52.5993 20.8125 53.8931Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8984 53.8924C21.8984 54.5858 22.4602 55.1482 23.153 55.1482C23.8457 55.1482 24.4075 54.5858 24.4075 53.8924C24.4075 53.199 23.8457 52.6367 23.153 52.6367C22.4602 52.6367 21.8984 53.199 21.8984 53.8924Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8281 69.3228C19.8281 70.6166 20.8757 71.6651 22.1682 71.6651C23.4608 71.6651 24.5083 70.6166 24.5083 69.3228C24.5083 68.029 23.4608 66.9805 22.1682 66.9805C20.8757 66.9805 19.8281 68.029 19.8281 69.3228Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9141 69.3221C20.9141 70.0155 21.4759 70.5778 22.1686 70.5778C22.8613 70.5778 23.4231 70.0155 23.4231 69.3221C23.4231 68.6287 22.8613 68.0664 22.1686 68.0664C21.4759 68.0664 20.9141 68.6287 20.9141 69.3221Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6328 63.2603C33.6328 64.5541 34.6804 65.6026 35.9729 65.6026C37.2654 65.6026 38.313 64.5541 38.313 63.2603C38.313 61.9665 37.2654 60.918 35.9729 60.918C34.6804 60.918 33.6328 61.9665 33.6328 63.2603Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7188 63.2596C34.7188 63.953 35.2805 64.5153 35.9733 64.5153C36.666 64.5153 37.2278 63.953 37.2278 63.2596C37.2278 62.5662 36.666 62.0039 35.9733 62.0039C35.2805 62.0039 34.7188 62.5662 34.7188 63.2596Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5667 78.462C22.8591 78.462 23.9067 77.4133 23.9067 76.1197C23.9067 74.826 22.8591 73.7773 21.5667 73.7773C20.2743 73.7773 19.2266 74.826 19.2266 76.1197C19.2266 77.4133 20.2743 78.462 21.5667 78.462Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 76.119C20.3125 76.8124 20.8743 77.3747 21.567 77.3747C22.2598 77.3747 22.8216 76.8124 22.8216 76.119C22.8216 75.4256 22.2598 74.8633 21.567 74.8633C20.8743 74.8633 20.3125 75.4256 20.3125 76.119Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6797 66.647C11.6797 67.9408 12.7272 68.9893 14.0198 68.9893C15.3123 68.9893 16.3599 67.9408 16.3599 66.647C16.3599 65.3532 15.3123 64.3047 14.0198 64.3047C12.7272 64.3047 11.6797 65.3532 11.6797 66.647Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7656 66.6463C12.7656 67.3397 13.3274 67.9021 14.0202 67.9021C14.7129 67.9021 15.2747 67.3397 15.2747 66.6463C15.2747 65.953 14.7129 65.3906 14.0202 65.3906C13.3274 65.3906 12.7656 65.953 12.7656 66.6463Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.637 93.0635C44.9294 93.0635 45.9771 92.0149 45.9771 90.7212C45.9771 89.4276 44.9294 88.3789 43.637 88.3789C42.3446 88.3789 41.2969 89.4276 41.2969 90.7212C41.2969 92.0149 42.3446 93.0635 43.637 93.0635Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3828 90.7206C42.3828 91.414 42.9446 91.9763 43.6373 91.9763C44.3301 91.9763 44.8919 91.414 44.8919 90.7206C44.8919 90.0272 44.3301 89.4648 43.6373 89.4648C42.9446 89.4648 42.3828 90.0272 42.3828 90.7206Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5156 96.7369C39.5156 98.0306 40.5632 99.0792 41.8557 99.0792C43.1483 99.0792 44.1958 98.0306 44.1958 96.7369C44.1958 95.4431 43.1483 94.3945 41.8557 94.3945C40.5632 94.3945 39.5156 95.4431 39.5156 96.7369Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6016 96.7362C40.6016 97.4296 41.1634 97.9919 41.8561 97.9919C42.5488 97.9919 43.1106 97.4296 43.1106 96.7362C43.1106 96.0428 42.5488 95.4805 41.8561 95.4805C41.1634 95.4805 40.6016 96.0428 40.6016 96.7362Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8245 100.243C51.1169 100.243 52.1646 99.1945 52.1646 97.9009C52.1646 96.6073 51.1169 95.5586 49.8245 95.5586C48.5321 95.5586 47.4844 96.6073 47.4844 97.9009C47.4844 99.1945 48.5321 100.243 49.8245 100.243Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5703 97.9003C48.5703 98.5936 49.1321 99.156 49.8248 99.156C50.5176 99.156 51.0794 98.5936 51.0794 97.9003C51.0794 97.2069 50.5176 96.6445 49.8248 96.6445C49.1321 96.6445 48.5703 97.2069 48.5703 97.9003Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5156 68.8736C39.5156 70.1673 40.5632 71.2159 41.8557 71.2159C43.1483 71.2159 44.1958 70.1673 44.1958 68.8736C44.1958 67.5798 43.1483 66.5312 41.8557 66.5312C40.5632 66.5312 39.5156 67.5798 39.5156 68.8736Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6016 68.8729C40.6016 69.5663 41.1634 70.1286 41.8561 70.1286C42.5488 70.1286 43.1106 69.5663 43.1106 68.8729C43.1106 68.1795 42.5488 67.6172 41.8561 67.6172C41.1634 67.6172 40.6016 68.1795 40.6016 68.8729Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4573 82.9815C42.7497 82.9815 43.7974 81.9328 43.7974 80.6392C43.7974 79.3456 42.7497 78.2969 41.4573 78.2969C40.1649 78.2969 39.1172 79.3456 39.1172 80.6392C39.1172 81.9328 40.1649 82.9815 41.4573 82.9815Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2031 80.6385C40.2031 81.3319 40.7649 81.8943 41.4577 81.8943C42.1504 81.8943 42.7122 81.3319 42.7122 80.6385C42.7122 79.9451 42.1504 79.3828 41.4577 79.3828C40.7649 79.3828 40.2031 79.9451 40.2031 80.6385Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8635 90.9229C16.1559 90.9229 17.2036 89.8742 17.2036 88.5806C17.2036 87.287 16.1559 86.2383 14.8635 86.2383C13.5711 86.2383 12.5234 87.287 12.5234 88.5806C12.5234 89.8742 13.5711 90.9229 14.8635 90.9229Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6094 88.5799C13.6094 89.2733 14.1712 89.8357 14.8639 89.8357C15.5566 89.8357 16.1184 89.2733 16.1184 88.5799C16.1184 87.8865 15.5566 87.3242 14.8639 87.3242C14.1712 87.3242 13.6094 87.8865 13.6094 88.5799Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8359 97.3853C25.8359 98.6791 26.8835 99.7276 28.176 99.7276C29.4686 99.7276 30.5161 98.6791 30.5161 97.3853C30.5161 96.0915 29.4686 95.043 28.176 95.043C26.8835 95.043 25.8359 96.0915 25.8359 97.3853Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9219 97.3846C26.9219 98.078 27.4837 98.6403 28.1764 98.6403C28.8691 98.6403 29.4309 98.078 29.4309 97.3846C29.4309 96.6912 28.8691 96.1289 28.1764 96.1289C27.4837 96.1289 26.9219 96.6912 26.9219 97.3846Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.762 115.087C39.0544 115.087 40.1021 114.038 40.1021 112.745C40.1021 111.451 39.0544 110.402 37.762 110.402C36.4696 110.402 35.4219 111.451 35.4219 112.745C35.4219 114.038 36.4696 115.087 37.762 115.087Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5078 112.744C36.5078 113.437 37.0696 114 37.7623 114C38.4551 114 39.0169 113.437 39.0169 112.744C39.0169 112.051 38.4551 111.488 37.7623 111.488C37.0696 111.488 36.5078 112.051 36.5078 112.744Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5979 126.763C24.8903 126.763 25.938 125.714 25.938 124.42C25.938 123.127 24.8903 122.078 23.5979 122.078C22.3055 122.078 21.2578 123.127 21.2578 124.42C21.2578 125.714 22.3055 126.763 23.5979 126.763Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3438 124.42C22.3438 125.113 22.9055 125.676 23.5983 125.676C24.291 125.676 24.8528 125.113 24.8528 124.42C24.8528 123.726 24.291 123.164 23.5983 123.164C22.9055 123.164 22.3438 123.726 22.3438 124.42Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2812 109.264C15.2812 110.558 16.3288 111.607 17.6213 111.607C18.9139 111.607 19.9614 110.558 19.9614 109.264C19.9614 107.97 18.9139 106.922 17.6213 106.922C16.3288 106.922 15.2812 107.97 15.2812 109.264Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3672 109.264C16.3672 109.957 16.929 110.519 17.6217 110.519C18.3144 110.519 18.8762 109.957 18.8762 109.264C18.8762 108.57 18.3144 108.008 17.6217 108.008C16.929 108.008 16.3672 108.57 16.3672 109.264Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9766 119.518C26.9766 120.812 28.0241 121.86 29.3167 121.86C30.6092 121.86 31.6567 120.812 31.6567 119.518C31.6567 118.224 30.6092 117.176 29.3167 117.176C28.0241 117.176 26.9766 118.224 26.9766 119.518Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0625 119.517C28.0625 120.211 28.6243 120.773 29.317 120.773C30.0098 120.773 30.5715 120.211 30.5715 119.517C30.5715 118.824 30.0098 118.262 29.317 118.262C28.6243 118.262 28.0625 118.824 28.0625 119.517Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9453 126.94C43.9453 128.234 44.9929 129.282 46.2854 129.282C47.5779 129.282 48.6255 128.234 48.6255 126.94C48.6255 125.646 47.5779 124.598 46.2854 124.598C44.9929 124.598 43.9453 125.646 43.9453 126.94Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0312 126.939C45.0312 127.633 45.593 128.195 46.2858 128.195C46.9785 128.195 47.5403 127.633 47.5403 126.939C47.5403 126.246 46.9785 125.684 46.2858 125.684C45.593 125.684 45.0312 126.246 45.0312 126.939Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2734 136.549C42.2734 137.843 43.321 138.892 44.6135 138.892C45.9061 138.892 46.9536 137.843 46.9536 136.549C46.9536 135.256 45.9061 134.207 44.6135 134.207C43.321 134.207 42.2734 135.256 42.2734 136.549Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3594 136.549C43.3594 137.242 43.9212 137.804 44.6139 137.804C45.3066 137.804 45.8684 137.242 45.8684 136.549C45.8684 135.855 45.3066 135.293 44.6139 135.293C43.9212 135.293 43.3594 135.855 43.3594 136.549Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4453 57.9048C38.4453 59.1986 39.4929 60.2471 40.7854 60.2471C42.0779 60.2471 43.1255 59.1986 43.1255 57.9048C43.1255 56.611 42.0779 55.5625 40.7854 55.5625C39.4929 55.5625 38.4453 56.611 38.4453 57.9048Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5312 57.9042C39.5312 58.5975 40.093 59.1599 40.7858 59.1599C41.4785 59.1599 42.0403 58.5975 42.0403 57.9042C42.0403 57.2108 41.4785 56.6484 40.7858 56.6484C40.093 56.6484 39.5312 57.2108 39.5312 57.9042Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2344 68.0689C46.2344 69.3626 47.2819 70.4112 48.5745 70.4112C49.867 70.4112 50.9146 69.3626 50.9146 68.0689C50.9146 66.7751 49.867 65.7266 48.5745 65.7266C47.2819 65.7266 46.2344 66.7751 46.2344 68.0689Z",
    fill: "white",
    fillOpacity: 0.52,
    stroke: "#687BA4",
    strokeOpacity: 0.95,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3203 68.0682C47.3203 68.7616 47.8821 69.3239 48.5748 69.3239C49.2676 69.3239 49.8294 68.7616 49.8294 68.0682C49.8294 67.3748 49.2676 66.8125 48.5748 66.8125C47.8821 66.8125 47.3203 67.3748 47.3203 68.0682Z",
    fill: "#8BB2DF",
    fillOpacity: 0.35
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26576_3806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 139,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceDiagram);
export default __webpack_public_path__ + "static/media/face-diagram.2b1c50512f47f78743e815a8cad87d57.svg";
export { ForwardRef as ReactComponent };